import React from 'react';
import classNames from 'classnames';


const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
         <a href="https://twitter.com/Dogecoin_V2">Twitter</a>
        </li>
        <li>
         <a href="https://t.me/Dogev2portal">Telegram</a>
        </li>
        <li>
          <a href="https://etherscan.io/address/0x47dea215ee41eedf84340f7e1ab501786cff6f62#code">Contract</a>
        </li>
       
      </ul>
    </nav>
  );
}

export default FooterNav;